import { useStyles } from './ErrorComponent.styles';
import SomethingCrashed from '../../assets/images/SomethingCrashed.png';
import { ErrorComponentProps } from './ErrorComponent.types';

import { Typography } from '../Typography';
import { Button } from '../buttons/Button';

export const ErrorComponent = ({ error }: ErrorComponentProps) => {
  const styles = useStyles();

  return (
    <div css={styles.root}>
      <div css={styles.iconContainer}>
        <div css={styles.iconPositionContainer}>
          <img
            css={{ objectFit: 'contain', width: '100%' }}
            src={SomethingCrashed}
            alt="Something Crashed"
          />
          <Typography variant="value">
            {/* @ts-expect-error */}
            {error.name}: {error.message}
          </Typography>
          <Typography variant="value">
            Press Reload button. If the error persist, please contact IT support
          </Typography>
          <Button size="md" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      </div>
    </div>
  );
};
